import { cn } from '../../lib/utils'
import { OUTCOME_STYLES, useOutcomeLabel, type Outcome } from './outcomeMeta'

export function OutcomeBadge({
  outcome,
  size = 'md',
}: {
  outcome: string | undefined | null
  size?: 'sm' | 'md'
}) {
  const label = useOutcomeLabel(outcome)
  if (!outcome) {
    return <span className="text-text-muted">—</span>
  }
  const style = OUTCOME_STYLES[outcome as Outcome] ?? 'bg-text-muted/20 text-text-secondary'
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs',
        style,
      )}
    >
      {label}
    </span>
  )
}
